// @ts-check

if (!customElements.get("cart-drawer"))
  customElements.define(
    "cart-drawer",
    class FfCartDrawer extends HTMLElement {
      /**
       * @type {HTMLButtonElement}
       * The button that redirect customer to the checkout
       */
      submit_button;
      upCrossSelling = {
        maxOriginProducts: 4, //products which originate the recommendations
        maxRetrievedProducts: 4, //products retrieved per recommendation fetch
        maxReturnedRecommendations: 10, //total products from all recommendations fetch
      };

      constructor() {
        super();

        if (location.pathname.includes("cart")) {
          this.remove();
        } else {
          this.init();
        }
      }

      init() {
        /**
         * @type {HTMLButtonElement | null}
         */
        const submitButton = this.querySelector(".checkout-button");

        if (submitButton) {
          this.submit_button = submitButton;
        }

        this.registerEvents();

        if (new URLSearchParams(location.search).get("show-cart") == "true") {
          setTimeout(() => this.show(), 300);
        }

        //Up cross selling element doesn't exist when the cart is empty
        if (this.querySelector("#up-cross-selling")) {
          this.initUpCrossSelling();
        }
      }

      registerEvents() {
        const closeButton = this.querySelector('.btn-close-drawer')
        const overlay = this.querySelector(".cart-overlay");
        const drawer = this.querySelector(".drawer");

        if (!closeButton || !overlay || !drawer) throw new Error();

        closeButton.addEventListener('click', () => {
          this.hide()
        })

        overlay.addEventListener("click", () => {
          this.hide();
        });

        drawer.addEventListener("transitionend", () => {
          const progress = parseFloat(this.dataset.progress || "0");

          /**
           * @type {HTMLDivElement | null}
           */
          const progressBar = this.querySelector(".shipping-progress");

          if (progressBar) {
            progressBar.style.width = `${progress}%`;
          }
        });
      }

      async initUpCrossSelling() {
        const {
          maxOriginProducts,
          maxRetrievedProducts,
          maxReturnedRecommendations,
        } = this.upCrossSelling;
        const promises = [];
        let allRecommendations = [];
        /**
         * @type {HTMLDivElement | null}
         */
        const upCrossSellingEl = this.querySelector("#up-cross-selling");
        if (
          !upCrossSellingEl ||
          !upCrossSellingEl.dataset.productsIds ||
          !upCrossSellingEl.dataset.url ||
          !upCrossSellingEl.dataset.intent
        )
          throw new Error();

        const swiper = new Swiper(".cart-drawer-swiper", {
          slidesPerView: 1.8,
          speed: 400,
          spaceBetween: 8,
          mousewheel: true,
          autoplay: {
            delay: 5000,
          },
          breakpoints: {
            767: {
              slidesPerView: 2,
              spaceBetween: 16,
            },
          },
        });

        const productsIds = Array.from(
          new Set(upCrossSellingEl?.dataset.productsIds?.split(","))
        );

        for (let i = 0; i < productsIds.length && i < maxOriginProducts; i++) {
          const url = `${upCrossSellingEl.dataset.url}?product_id=${productsIds[i]}&intent=${upCrossSellingEl.dataset.intent}&limit=${maxRetrievedProducts}`;

          const promise = (async () => {
            const response = await fetch(url);
            const { products } = await response.json();
            allRecommendations = [...allRecommendations, ...products];
          })();

          promises.push(promise);
        }

        await Promise.allSettled(promises);

        allRecommendations
          .reduce((acc, curr) => {
            if (!acc.find((item) => item.id === curr.id)) {
              acc.push(curr);
            }
            return acc;
          }, [])
          .slice(0, maxReturnedRecommendations)
          .forEach((product, idx) => {
            const recommendationCard = this.recommendationCard(product, idx);

            if (recommendationCard) swiper.appendSlide(recommendationCard);
          });
      }

      /**
       *
       * @param {{variants: {id:string, price:number, name:string, available:boolean}[], featured_image:string, url:string}} product
       */
      recommendationCard(product, slideIdx) {
        const { featured_image, url, variants } = product;
        const firstVariantAvailable = variants.find(
          ({ available }) => available == true
        );

        if (!firstVariantAvailable) return undefined;
        const { price, name, id } = firstVariantAvailable;

        return `
            <ff-recommendation-card class="recommendation swiper-slide" data-variant-id="${id}" data-slide-idx="${slideIdx}">
              <a class="img-container" href="${url}">
                <img
                  src=${featured_image}&width=100
                  height="70"
                  width="70"
                >
              </a>
              <div class="column">
                <a href="${url}"><h3 class="ff-max-lines-2 ff-text--color-base ff-text--sm">${name}</h3></a>
                <span class="price subdued ff-text--xs">
                ${new Intl.NumberFormat("de-DE", {
                  style: "currency",
                  currency: "EUR",
                }).format(price / 100)}
                </span>
                <button class="add-to-cart ff-general-drawer_add_recommendation">
                  Agregar
                </button>
              </div>
            </ff-recommendation-card>
          `;
      }

      /**
       * @param {boolean} value Indicates if the submit button must be enable or disable
       */
      enable(value) {
        if (value) {
          this.submit_button.removeAttribute("disable");
        } else {
          this.submit_button.setAttribute("disable", "disable");
        }
      }

      toggle() {
        this.classList.toggle("active");
      }

      show() {
        this.classList.add("active");
      }

      hide() {
        this.classList.remove("active");
      }

      getSectionsToRender() {
        return [
          {
            id: this.id,
          },
          {
            id: "cart-icon-bubble",
          },
        ];
      }

      renderContents(parsedState) {
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = section.selector
            ? document.querySelector(section.selector)
            : document.getElementById(section.id);

          const newSectionElement = this.getSectionInnerHTML(
            parsedState.sections[section.id],
            section.selector
          );

          if (!sectionElement) {
            return;
          } else if (section.id == this.id) {
            this.renderSelf(parsedState.sections[section.id]);
          } else {
            sectionElement.innerHTML = newSectionElement;
          }
        });
        this.show();
      }

      getSectionInnerHTML(html, selector = ".shopify-section") {
        return new DOMParser()
          .parseFromString(html, "text/html")
          .querySelector(selector).innerHTML;
      }

      renderSelf(section) {
        const sectionDOM = new DOMParser().parseFromString(
          section,
          "text/html"
        );

        const newDrawerItems =
          sectionDOM.querySelector(".drawer-items")?.innerHTML;

        const drawerItems = this.querySelector(".drawer-items");

        if (newDrawerItems && drawerItems) {
          const newProgress = parseFloat(
            sectionDOM
              .querySelector("cart-drawer")
              ?.getAttribute("data-progress") || "0"
          );
          const newFreeShippingMsg =
            sectionDOM.querySelector(".free-shipping-msg")?.innerHTML;
          const newTotalCart = sectionDOM.querySelector(".totals")?.innerHTML;
          const newWarningMessage = sectionDOM.querySelector(
            ".cart-resume-warning"
          );

          const cartTotalPriceEl = this.querySelector(".totals");
          const freeShippingMsgEl = this.querySelector(".free-shipping-msg");
          const progressBar = this.querySelector(".shipping-progress");
          const warningMessage = this.querySelector(".cart-resume-warning");
          const checkoutButton = this.querySelector(".checkout-button");

          if (newWarningMessage && warningMessage && checkoutButton) {
            // @ts-ignore
            warningMessage.style.display = newWarningMessage.style.display;
            warningMessage.innerHTML = newWarningMessage.innerHTML;

            // @ts-ignore
            const allow = newWarningMessage.style.display === "none";

            if (allow) {
              checkoutButton.removeAttribute("disabled");
            } else {
              checkoutButton.setAttribute("disabled", "disabled");
            }
          }

          if (cartTotalPriceEl && newTotalCart) {
            cartTotalPriceEl.innerHTML = newTotalCart;
          }

          if (progressBar) {
            this.dataset.progress = newProgress.toString();
            // @ts-ignore
            progressBar.style.width = `${newProgress}%`;
          }

          if (newFreeShippingMsg && freeShippingMsgEl) {
            freeShippingMsgEl.innerHTML = newFreeShippingMsg;
          }

          drawerItems.innerHTML = newDrawerItems;
          drawerItems.scrollBy({
            top: -drawerItems.scrollHeight,
            behavior: "smooth",
          });
        } else {
          const newDrawerContent = sectionDOM.querySelector(".drawer");

          const currentDrawerContent = this.querySelector(".drawer");

          if (newDrawerContent && currentDrawerContent) {
            currentDrawerContent.replaceWith(newDrawerContent);
            const newProgress = parseFloat(
              sectionDOM
                .querySelector("cart-drawer")
                ?.getAttribute("data-progress") || "0"
            );
            this.dataset.progress = newProgress.toString();
            this.init();
          }
        }
      }

      // This method only exists to have compatibility with product-form
      setActiveElement() {}
    }
  );

if (!customElements.get("ff-cart-item"))
  customElements.define(
    "ff-cart-item",
    class FfCartItem extends HTMLElement {
      /**
       * @type {string}
       * The id associated to the cart line
       */
      lineId;

      /**
       * @type {HTMLInputElement}
       * The input where line quantity is defined
       */
      inputQty;

      /**
       * @type {HTMLDivElement}
       * The cart drawer element parent of this drawer item
       */
      cartDrawer;

      /**
       * @type {number}
       * Store the current quantity for the line, just in case a quantity update couldn't be done
       */
      prevQty;

      constructor() {
        super();

        this.lineId = this.id.replace("line-", "");

        /**
         * @type {HTMLSpanElement | null}
         */
        const minusQty = this.querySelector("#minus-quantity");
        /**
         * @type {HTMLInputElement | null}
         */
        const inputQty = this.querySelector("#line-quantity");
        /**
         * @type {HTMLSpanElement | null}
         */
        const plusQty = this.querySelector("#plus-quantity");
        /**
         * @type {HTMLElement | null}
         */
        const removeBtn = this.querySelector(".remove-btn");
        /**
         * @type {FfCartDrawer | null}
         */
        const cartDrawer = this.closest("cart-drawer");

        if (!minusQty || !inputQty || !plusQty || !cartDrawer || !removeBtn)
          throw new Error();

        this.cartDrawer = cartDrawer;
        this.inputQty = inputQty;
        this.prevQty = parseInt(inputQty.value);

        minusQty.addEventListener("click", async () => {
          const isLoading = this.classList.contains("loading");

          if (isLoading) return;

          const newQty = parseInt(inputQty.value || "0") - 1;

          this.inputQty.value = newQty.toString();

          await this.changeQty(newQty);
        });

        plusQty.addEventListener("click", async () => {
          const isLoading = this.classList.contains("loading");

          if (isLoading) return;

          const newQty = parseInt(inputQty.value || "0") + 1;

          this.inputQty.value = newQty.toString();

          await this.changeQty(newQty);
        });

        inputQty.addEventListener("change", async () => {
          const newQty = parseInt(inputQty.value || "0");

          await this.changeQty(newQty);
        });

        removeBtn.addEventListener("click", async () => {
          await this.changeQty(0);
        });
      }

      /**
       * @param {number} newQty The new qty for the line
       */
      async changeQty(newQty) {
        this.classList.add("loading");

        this.inputQty.setAttribute("disabled", "disabled");
        // @ts-ignore
        this.cartDrawer.enable(false);

        try {
          const res = await fetch(
            `${window["Shopify"].routes.root}cart/update.js`,
            {
              method: "POST",
              headers: {
                "Content-Type": "application/json",
              },
              body: JSON.stringify({
                updates: { [this.lineId]: newQty <= 0 ? 0 : newQty },
                // @ts-ignore
                sections: this.cartDrawer
                  .getSectionsToRender()
                  .map((section) => section.id),
              }),
            }
          );

          const result = await res.json();

          if (result?.status === 422) {
            this.inputQty.value = this.prevQty.toString();
          } else {
            this.prevQty = newQty;

            this.cartDrawer.renderContents(result);
          }
        } catch (error) {
          console.log(error);

          this.inputQty.value = this.prevQty.toString();
        } finally {
          this.classList.remove("loading");

          this.inputQty.removeAttribute("disabled");

          // @ts-ignore
          this.cartDrawer.enable(true);
        }
      }
    }
  );

if (!customElements.get("ff-recommendation-card")) {
  customElements.define(
    "ff-recommendation-card",
    class FfRecommendationCard extends HTMLElement {
      constructor() {
        super();
        /**
         * @type {HTMLButtonElement | null}
         */
        this.addToCartBtn = this.querySelector(".add-to-cart");

        if (!this.addToCartBtn) throw new Error();
        this.addToCartBtn.addEventListener("click", this.addToCart.bind(this));
      }

      async addToCart() {
        this.addToCartBtn?.classList.add("btn--loading");
        this.addToCartBtn?.setAttribute("disabled", "disabled");

        /**
         * @type {FfCartDrawer | null}
         */
        const cartDrawer = document.querySelector("cart-drawer");
        cartDrawer.enable(false);

        const swiper = document.querySelector("#up-cross-selling")?.swiper;

        if (!this.dataset.variantId || !cartDrawer || !swiper)
          throw new Error();

        swiper.autoplay.stop();

        const id = parseInt(this.dataset.variantId);

        const requestData = {
          items: [{ id, quantity: 1 }],
          sections: cartDrawer
            .getSectionsToRender()
            .map((section) => section.id),
        };

        await fetch(`${window["Shopify"].routes.root}cart/add.js`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(requestData),
        })
          .then((response) => {
            return response.json().then((data) => {
              cartDrawer.renderContents(data);

              return data;
            });
          })
          .catch((error) => {
            console.error("Error:", error);
            throw error;
          });

        this.addToCartBtn?.classList.remove("btn--loading");
        this.addToCartBtn?.removeAttribute("disabled");
        cartDrawer.enable(true);

        swiper.removeSlide(this.dataset.slideIdx);
        swiper.update();
        swiper.autoplay.start();

        document
          .querySelectorAll("#up-cross-selling .swiper-slide")
          .forEach((slide, idx) =>
            slide.setAttribute("data-slide-idx", idx.toString())
          );
      }
    }
  );
}
